import { Component, inject, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { ShowCasesService } from 'app/shared/services/show-cases.service';
import { ActivationTypeEnum } from 'app/shared/enums/showcases.enum';
import { ShowcaseInputModel } from 'app/shared/models/showcases.model';
import { ShopContextStore } from 'app/shared/state/shop-context.store';

@Component({
    selector: 'app-showcases-filter',
    templateUrl: './showcases-filter.component.html',
    styleUrls: ['./showcases-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ShowcasesFilterComponent {
  
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();
  
  searchSettings: SearchSettings = {
    placeholder: 'Search showcase...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };
  
  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];
  
  private _shopContext = inject(ShopContextStore);

  constructor(
    private _showcases: ShowCasesService,
  ) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }
  
  onSearch(search: string) {
    this.searchValue = search;
    if (search === ''){ 
      this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    }
    this.setDataToView(0);
  }
  
  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }
  
  setDataToView(skipCount: number) {
    const params: ShowcaseInputModel = {
      storeId: this._shopContext.currentShop().id,
      skipCount: skipCount,
      maxResultCount: 20,
      searchString: this.searchValue ?? null,
      activationType: ActivationTypeEnum.All,
      sorting: 'id desc'
    }

    this._showcases.getList(params, this.loaderId).subscribe(element => {
      this.dataToView = element.items.map(el => FilterMapper.ShowcaseFilter(el));
      this.totalCount = element.totalCount + 1;
    });
  }
  
}
